import DtoOperationReferencial from './DtoOperationReferencial'

export default class DtoFraction extends DtoOperationReferencial {
    constructor(obj) {
        super(obj)
    }
}
